<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增客户
      </el-button>
      <div class="former">
        <el-input
          v-model="form['ClientName:like']"
          placeholder="客户名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <el-cascader
          v-model="area"
          :options="options"
          :props="props"
          clearable
          placeholder="请选择地区"
          :show-all-levels="true"
          :emitPath="false"
        ></el-cascader
        >&nbsp;
        <el-select
          v-model="businessGroups"
          multiple
          collapse-tags
          :clearable="true"
          placeholder="请选择业务组分类"
          filterable
        >
          <el-option
            v-for="code in businessGroupList"
            :key="code.Type"
            :label="code.Name"
            :value="code.Type"
          ></el-option> </el-select
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="ClientNumber" label="客户编号">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.ClientNumber }}
          </el-tag>
        </template></el-table-column
      >
      <el-table-column prop="ClientName" label="客户名称"></el-table-column>
      <el-table-column label="所属地区">
        <template slot-scope="scope">
          <span v-if="scope.row.Province">{{ scope.row.Province.Name }}</span>
          <span v-if="scope.row.City">/{{ scope.row.City.Name }}</span>
          <span v-if="scope.row.County">/{{ scope.row.County.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="业务组分类" width="200">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(code, index) in row.BusinessGroups"
            :key="index"
            style="margin-right: 5px; color: #00b3ca"
            >{{ getBusinessGroup(code) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="PlatformsCount"
        label="平台个数"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="ContractsCount"
        label="合同数量"
        width="100"
      ></el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            :disabled="scope.row.ContractsCount !== 0"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :businessGroupList="businessGroupList"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      props: {
        value: "CodeID",
        label: "Name",
        children: "Children",
        checkStrictly: true,
      },
      area: [0, 0, 0],
      businessGroups: [],
      businessGroupList: [],
      options: [],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        "ClientName:like": "",
        ProvinceCodeID: "",
        CityCodeID: "",
        CountyCodeID: "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
    };
  },
  mounted() {
    this.getItemList();
    this.getBusinessGroupList();
    this.choseArea();
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      if (this.area[0]) this.form.ProvinceCodeID = this.area[0];
      else this.form.ProvinceCodeID = "";
      if (this.area[1]) this.form.CityCodeID = this.area[1];
      else this.form.CityCodeID = "";
      if (this.area[2]) this.form.CountyCodeID = this.area[2];
      else this.form.CountyCodeID = "";
      this.$axios
        .get("client", {
          params: {
            where: this.form,
            BusinessGroups: this.businessGroups,
            with: [
              "Platforms/count",
              "Province",
              "City",
              "County",
              "Contracts/count",
            ],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //业务组分类
    getBusinessGroupList() {
      this.$axios
        .get("basic", {
          params: {
            type: "BusinessGroup",
          },
        })
        .then((response) => {
          this.businessGroupList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getBusinessGroup(code) {
      let name = "";
      this.businessGroupList.forEach((item) => {
        if (item.Type === code) {
          name = item.Name;
        }
      });
      return name;
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 编辑
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除此客户吗？", "提示")
        .then(() => this.$axios.delete(`client/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {};
    },
    choseArea() {
      this.$axios
        .get("area")
        .then((response) => {
          this.options = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
  },
};
</script>
